import { ActivityIndicator, Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Users } from 'lucide-react-native'
import { colors } from '@chillout/core'

interface TotalMembersBadgeProps {
  value: number
  loading?: boolean
}

export function TotalMembersBadge({ value, loading }: TotalMembersBadgeProps) {
  const { t } = useTranslation()

  return (
    <View className="shrink-0 flex-row items-center gap-3 rounded-lg bg-canvas-primary px-4 py-3">
      <View
        className="h-11 w-11 shrink-0 items-center justify-center rounded-full"
        style={{ backgroundColor: `${colors.accent.DEFAULT}1A` }}
      >
        <Users size={20} color={colors.accent.DEFAULT} strokeWidth={2} />
      </View>
      {loading
        ? <ActivityIndicator size="small" color={colors.text.muted} />
        : (
          <View>
            <Text className="text-2xl font-bold text-primary">{value.toLocaleString()}</Text>
            <Text className="text-sm font-medium text-secondary">{t('adminDashboard.home.totalMembers.label')}</Text>
            <Text className="text-xs font-normal text-muted">{t('adminDashboard.home.totalMembers.allTime')}</Text>
          </View>
        )
      }
    </View>
  )
}
